const I = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNTEzIDM0MiI+CjxyZWN0IHk9IjAiIGZpbGw9IiNGRkZGRkYiIHdpZHRoPSI1MTMiIGhlaWdodD0iMzQyIi8+CjxnIGZpbGw9IiM2ZGE5ZDIiPgoJPHJlY3QgeT0iMjM4IiB3aWR0aD0iNTEzIiBoZWlnaHQ9IjEwNCIvPgoJPHJlY3QgeT0iMCIgd2lkdGg9IjUxMyIgaGVpZ2h0PSIxMDQiLz4KPC9nPgo8cmVjdCB5PSIxMjUuNSIgd2lkdGg9IjUxMyIgaGVpZ2h0PSI4OS42NTYiLz4KPC9zdmc+Cg==";
export {
  I as default
};
//# sourceMappingURL=BW-fb15d543.mjs.map
